import { render } from "./OrgTypePicker.html?vue&type=template&id=ef8c4694&scoped=true&ts=true"
import script from "./OrgTypePicker.ts?vue&type=script&lang=ts"
export * from "./OrgTypePicker.ts?vue&type=script&lang=ts"

import "./OrgTypePicker.scss?vue&type=style&index=0&id=ef8c4694&lang=scss&scoped=true"

import exportComponent from "D:\\DEV\\Vue\\work\\vue_sotec_main\\vue_sotec_main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef8c4694"]])

export default __exports__